<div class="ai-filter-panel mat-elevation-z1 bg-white rounded p-3 mb-4">
  <div class="d-flex align-items-center gap-3 flex-wrap">
    
    <div class="d-flex align-items-center me-3 text-secondary">
      <mat-icon class="me-2">filter_alt</mat-icon>
      <span class="fw-bold">Filtros IA</span>
    </div>

    <!-- Filtro por Rival -->
    <mat-form-field appearance="outline" class="mb-0 custom-field">
      <mat-label>Comparativa vs Rival</mat-label>
      <mat-select [(ngModel)]="selectedOpponentId" (selectionChange)="onFilterChange()">
        <mat-option [value]="null">Todos los Análisis</mat-option>
        <mat-option *ngFor="let opp of opponentOptions()" [value]="opp.id">
          {{ opp.name }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <!-- Filtro por Partido Concreto -->
    <mat-form-field appearance="outline" class="mb-0 custom-field">
      <mat-label>Partido Concreto</mat-label>
      <mat-select [(ngModel)]="selectedVideoId" (selectionChange)="onFilterChange()">
        <mat-option [value]="null">Todos los partidos seleccionados</mat-option>
        <mat-option *ngFor="let match of matchOptions()" [value]="match.id">
          {{ match.title }}<span *ngIf="match.date"> - {{ match.date | date:'dd/MM/yyyy' }}</span>
        </mat-option>
      </mat-select>
    </mat-form-field>
    
    <!-- Limpiar -->
    <button mat-button color="warn" *ngIf="selectedOpponentId || selectedVideoId" (click)="clearFilters()">
      Limpiar Filtro
    </button>
    
  </div>
</div>
